<template>
  <div class="box">
    <div class="asstsCard">
      <p class="asstsCardTitle">奖品</p>
      <p class="asstsCardNum">数字资产查询 X1</p>
      <p class="asstsCardAddres">免费数字资产查询机会，来一起围观大佬们的钱包</p>
    </div>
    <a v-if="!asstsStutas" class="Qclick1" @click="qClick">抢</a>
    <a v-if="asstsStutas" class="Qclick2" @click="goTop">成功抢到<br/>去查询</a>
    <p class="allnum">已有{{invList.length}}位好友抢成功</p>
    <div class="shareFriendList">
      <p v-for="item in invList" :key="item.key">用户{{item.toInvitationPhoneHide}} {{item.goDate}} 抢成功</p>
    </div>
    <div class="successTip" v-if="TipStutas">
      {{TipStutasText}}
    </div>
  </div>
</template>

<script>
import Config from '../config/index'
import callApi from '../../static/callApi'
import qs from 'qs'
export default {
  name: 'share',
  data () {
    return {
      TipStutas: false,
      TipStutasText: '',
      asstsStutas: false,
      successTipStutas: false,
      invitation: '',
      invList: []
    }
  },
  created: function () {
    if (this.$route.query.invitation) {
      this.invitation = this.$route.query.invitation
      this.getShareInfo()
    } else {
      this.$router.push({path: '/'})
    }
  },
  methods: {
    qClick: function () {
      let _this = this
      callApi({
        method: 'POST',
        url: Config.path + '/fbeeapi/invitation/add',
        headers: {versioncode: 1.0, platform: 'smallprogram', 'Content-Type': 'application/x-www-form-urlencoded'},
        data: qs.stringify({invitation: this.invitation})
      }, (response) => {
        if (response.data.success === '1') {
          response.data.content === 1 ? _this.openmessage('标记成功，获得奖励次数') : _this.openmessage('标记成功')
          _this.loading2 = true
          _this.asstsQueryNow()
          _this.bjStatus = false
        } else {
          this.openmessage(response.data.message)
        }
      }, this)
    },
    openmessage: function (msg) {
      let _this = this
      this.TipStutasText = msg
      this.TipStutas = true
      setTimeout(function () {
        _this.TipStutasText = ''
        _this.TipStutas = false
      }, 2000)
    },
    getShareInfo: function () {
      let _this = this
      callApi({
        method: 'GET',
        url: Config.path + '/fbeeapi/invitation/list',
        headers: {versioncode: 1.0, platform: 'smallprogram'},
        params: {invitation: this.invitation}
      }, (response) => {
        if (response.data.success === '1') {
          _this.invList = response.data.content.assetInvitationList
        } else if (response.data.success === '000004') {
          _this.openmessage('邀请码有误')
          setTimeout(function () {
            _this.$router.push({path: '/'})
          }, 2000)
        } else {
          _this.openmessage('error')
          setTimeout(function () {
            _this.$router.push({path: '/'})
          }, 2000)
        }
      }, this)
    },
    goTop: function () {
      this.$router.push({path: '/'})
    }
  }
}
</script>

<style scoped>
  .box{
    background-color: #0A274A;
    width: 100%;
    height: 21.893rem;
    background-image: url("/static/background1.png");
    background-size: 100% auto;
    /*background-position: 0 -2.268rem;*/
    background-position: 0;
    background-repeat: no-repeat;
  }
  .asstsCard{
    width: 9.0667rem;
    height: 3.7333rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0.66667rem;
    background-image: linear-gradient(-156deg, #2DA2FC 0%, #0372C7 96%);
    border-radius: 0.26667rem;
    box-shadow: 0 0.45rem 20px 0px #0000009c;
  }
  .asstsCard .asstsCardTitle{
    opacity: 0.5;
    font-family: PingFangSC-Medium;
    font-size: 0.4rem;
    color: #FFFFFF;
    position: absolute;
    left: 0.507rem;
    top: 0.56rem;
  }
  .asstsCard .asstsCardNum{
    /* 417245.06: */
    font-family: PingFangSC-Medium;
    font-size: 0.9333rem;
    color: #FFFFFF;
    letter-spacing: -0.0349rem;
    position: absolute;
    left: 0.507rem;
    top: 1.24rem;
  }
  .asstsCard .asstsCardAddres{
    /* 0x543E56a8923613D292: */
    opacity: 0.5;
    font-family: PingFangSC-Medium;
    font-size: 0.293rem;
    color: #FFFFFF;
    position: absolute;
    left: 0.507rem;
    top: 2.747rem;
  }
  .Qclick1{
    width: 3.6rem;
    height: 3.6rem;
    border-radius: 100%;
    background-image: linear-gradient(-165deg, #FCEF22 0%, #FFDA28 100%);
    display: block;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 5.347rem;
    font-family: PingFangSC-Medium;
    font-size: 0.6667rem;
    color: #744A05;
    text-align: center;
    line-height: 3.6rem;
    box-shadow: 0px 0px 0.2667rem #fdeb22;
  }
  .Qclick2{
    width: 3.6rem;
    height: 3.6rem;
    border-radius: 100%;
    background-image: linear-gradient(-165deg, #FCEF22 0%, #FFDA28 100%);
    display: block;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 5.347rem;
    color: #744A05;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 0.427rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 0px 0.2667rem #fdeb22;
  }
  .allnum{
    font-family: PingFangSC-Medium;
    font-size: 0.427rem;
    color: #FFFFFF;
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 9.613rem;
  }
  .shareFriendList{
    width: 7.56rem;
    height: 6.347rem;
    position: absolute;
    top: 10.693rem;
    left: 50%;
    transform: translateX(-50%);
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .shareFriendList p{
    font-family: PingFangSC-Medium;
    font-size: 0.3733rem;
    color: #FFFFFF;
  }
  .successTip{
    opacity: 0.8;
    background: #000000;
    border-radius: 0.267rem;
    position: fixed;
    top: 7.147rem;
    left: 50%;
    transform: translateX(-50%);
    height: 2.66667rem;
    width: 5.333rem;
    font-family: PingFangSC-Regular;
    font-size: 0.427rem;
    color: #FFFFFF;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/share.vue